import { ChangeEvent } from "react";

interface Props {
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  className?: string;
}

export default function Checkbox({
  checked,
  onChange,
  id,
  name,
  className = "",
}: Props) {
  return (
    <label
      htmlFor={id}
      className={`inline-flex items-center cursor-pointer ${className}`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="peer hidden"
      />

      <div
        className={`w-6 h-6 rounded-lg transition-colors duration-200 relative 
        ${checked ? "bg-[#0B2F9F]" : "bg-gray-300"}`}
      >
        <svg
          className={`w-5 h-5 text-white absolute top-1/2 left-1/2 transform 
          -translate-x-1/2 -translate-y-1/2 transition-opacity duration-200 
          ${checked ? "opacity-100" : "opacity-0"}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
    </label>
  );
}
